import { Injectable } from '@angular/core';
import {
  DeliveryDateService,
  CalendarDate,
  CartRow,
  Product,
  ProductService,
  CartService,
  GungFlowService
} from 'gung-standard';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, mapTo, switchMap } from 'rxjs';
import { getDay, getHours, isAfter, differenceInDays } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class ColmecDeliveryDatesService extends DeliveryDateService {
  constructor(
    http: HttpClient,
    protected productService: ProductService,
    protected cartService: CartService,
    protected gungFlowService: GungFlowService
  ) {
    super(http, gungFlowService);
  }

  public getDeliveryDates(deliveryMethod: string, rows?: CartRow[]): Observable<CalendarDate[]> {
    return this.cartService.getCurrentCart().pipe(
      switchMap((cartRows: CartRow[]) => {
        const ids = cartRows.map(row => row.productId);

        let hasSiping = false;
        let hasSpikes = false;
        let hasAssembly = false;
        cartRows.forEach(row => {
          hasSiping = hasSiping || row.extra._colmecSipingSelected;
          hasSpikes = hasSpikes || row.extra._colmecDubbingSelected;
          hasAssembly = hasAssembly || !!(row.extra.configure && row.extra.configure.assembly);
        });

        return this.productService.getProductsByIds(ids).pipe(
          switchMap(products => {
            const productsMap = {};
            products.forEach(product => (productsMap[product.id] = product));

            let totalVolume = 0;

            let targetStockLocation = '0';
            if (cartRows.length > 0) {
              targetStockLocation = cartRows[0].targetStockId;
            }
            cartRows.forEach(row => {
              const product = productsMap[row.productId];
              const artvolym = product.extra.ar.artvolym || 0;
              totalVolume += row.qty * artvolym;
            });
            const url = `json/colmec-delivery-dates?deliveryMethodCode=${
              deliveryMethod || ''
            }&targetStockLocation=${targetStockLocation}&volumeOfCartContents=${
              totalVolume || 0
            }&hasSpikes=${hasSpikes}&hasSiping=${hasSiping}`;

            return this.http.get<CalendarDate[]>(url).pipe(
              map(dates => {
                let index = 0;

                const deliveryDates = dates.map(date => {
                  if (index < 6 && (hasSpikes || hasSiping || hasAssembly)) {
                    const realdate = new Date(date.date);
                    // Disable 3 weekdays
                    if (realdate.getDay() < 6) {
                      date.valid = false;
                      date.invalidReason = 'HAS SIPING OR DUBBING OR ASSEMBLY';
                      index++;
                    }
                  }
                  return {
                    ...date,
                    date: new Date(date.date)
                  };
                });

                // If current time is Friday after 13h, or is saturday or is sunday
                // Then make sure the next Monday is not valid
                const now = new Date();
                if ((getDay(now) === 5 && getHours(now) >= 13) || getDay(now) === 6 || getDay(now) === 0) {
                  const nextMonday = deliveryDates.find(
                    deliveryDate =>
                      getDay(deliveryDate.date) === 1 &&
                      isAfter(deliveryDate.date, now) &&
                      differenceInDays(deliveryDate.date, now) < 4
                  );

                  if (nextMonday && nextMonday.valid) {
                    nextMonday.invalidReason = 'IS FRIDAY AFTERNOON OR WEEKEND';
                    nextMonday.valid = false;
                  }
                }

                return deliveryDates;
              })
            );
          })
        );
      })
    );
  }
}
